export default "__VITE_ASSET__DhwUaJrx__"